export class ProductResource {
  id: number;
  label: string;
  link: string;
  isDefault: boolean;
  type: string;
  file: File;
  productId: number;
}
